 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		93: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","4":"ibdPage","6":"components-product_post-product_post~layouts~post-content-sidebar","7":"header~layouts~post-content-body","8":"giftguide","9":"legacyIbdPage","10":"ad-AdContainer","11":"components-analytics-analytics","12":"container","13":"fc_executive_board","14":"fc_link-fc_link","15":"aboutUsWpPage","16":"author","17":"category_page","18":"companyIndexSectionPage","19":"companyPage","20":"components-all_feed-all_feed","21":"components-feature_feed-feature_feed","22":"components-feature_term-feature_term","23":"components-franchise_showcase-franchise_showcase","24":"components-megatron-megatron","25":"components-more-stories-component-more-stories-component","26":"components-not_found_component-not_found_component","27":"components-slug-slug","28":"components-video_module-video_module","29":"customCollectionPage","30":"giftpage","31":"loginPage","32":"logoutPage","33":"magazineTagPage","34":"magazine_page","35":"myAccountPage","36":"newsletters_page_marketo","37":"notFoundPage","38":"offerPage","39":"personPage","40":"playlistIndexPage","41":"playlistPage","42":"podcastPage","43":"post_page","44":"productIndex","45":"productPage","46":"registerPage","47":"resetPasswordPage","48":"sitemapIndex","49":"sitemapPost","50":"subscribePage","51":"tagPage","52":"videoIndex","53":"videoPage","54":"views-containers-layouts-blank_layout-blank_layout","55":"views-containers-layouts-web_layout-web_layout","88":"MarketoNewsletterForm","89":"MicCarousel","90":"MicIcon","91":"MicMobileIconCarousel","92":"Success-SubmissionSuccess","94":"applications-most-innovative-companies","95":"brands_that_matter_list_page","96":"brands_that_matter_page","97":"categoryLink","98":"components-BackgroundHighlight-BackgroundHighlight","99":"components-MultiTabList-MultiTabList","100":"components-QuickCarousel-QuickCarousel","101":"components-StickyBar-StickyBar","102":"components-categories","103":"components-config-config","104":"components-editor_highlights-editor_highlights","105":"components-finite_scroll","106":"components-footer-footer","107":"components-franchise_accordion_section-franchise_accordion_section","108":"components-franchise_intro-franchise_intro","109":"components-ibd_category-ibd_category","110":"components-image-image","111":"components-magazine_archive-magazine_archive","112":"components-masthead-masthead","113":"components-mcp_section-mcp_section","114":"components-mic_mobile_menu-mic_mobile_menu","115":"components-newsletters-recaptcha","116":"components-notice","117":"components-person_company_component-person_company_component","118":"components-piano-pianoBottomBanner","119":"components-podcast_tile-podcast_tile","120":"components-podcast_tile-podcast_tile_featured","121":"components-post-content-insert","122":"components-product_post-product_post","123":"components-ranked","124":"components-recirc-recirc","125":"components-related_posts-related_posts","126":"components-related_slider-related_slider","127":"components-sectors_list-sectors_list","128":"components-social","129":"components-social-social","130":"components-top_50-top_50","131":"components-top_50_shuffle-top_50_shuffle","132":"components-video_megatron-video_megatron","133":"components-video_module-utils-video_module_ads","134":"containers-pages-list_landers-bwi-2020","135":"containers-pages-list_landers-ibd-2020","136":"containers-pages-list_landers-mic-2021","137":"content-innovation_festival_banner","138":"fc-components-main-components","139":"fc-components-main-components-StickyBar-StickyBar","140":"fc-components-main-containers","141":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","142":"fc-components-main-containers-IbdLayout-IbdLayout","143":"fc-components-main-containers-WciLayout-WciLayout","144":"fc-components-main-utils-ConditionalWrapper","145":"franchises-BtmApplyPage","146":"franchises-BwiApplyPage","147":"franchises-IbdApplyPage","148":"franchises-MicApplyPage","149":"franchises-NbttApplyPage","150":"franchises-WciApplyPage","151":"header","152":"innovation_by_design_future_page","153":"innovation_by_design_page_franchise","154":"layouts","155":"layouts-mcp","156":"nav_main_menu-nav_main_menu","157":"package_article_list_entry","158":"packages-nav-package_sticky_nav","159":"post-content-body","160":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"ff33f4c9c8fb8b97fdac","2":"673a1a0a6a15f8032063","3":"36c0507e75daf295efa6","4":"f1ba80fd49dfe274d54a","5":"924420a24fa6b523b1f8","6":"40521362637f470d866d","7":"20f6849817fbf05e39c7","8":"2456f03796937684c225","9":"6cf987b20d21771d170b","10":"008576e9cee99f23ad8b","11":"1853f626b6fe34e3dfbe","12":"377b405afaafb7fd7f0a","13":"883cbc795d5e51908e22","14":"06154e0e0905d9b1160c","15":"ea6c027d1af61361f1ed","16":"11417e095507a30326ba","17":"506c7ce10f386b9c6bbd","18":"fa6cacb4af3235bbe031","19":"ad29298eb0f5533c6628","20":"69d2a43539155beea4a8","21":"622e220d3e8c373a0058","22":"aa8bda954c14e50fd2a9","23":"4bf682b931f6e3978aea","24":"6b5163c9f19b20ff48dc","25":"befb82f6a3597aaa7ffd","26":"8b44707549de30c0f81f","27":"5c248bdff87060ef02cf","28":"6897b1910ae75af12e1d","29":"edc3997699d25b06cf66","30":"92de1ce52b8c48f3d7d5","31":"7be6ef721d483ef8015e","32":"ae2a7bc44c43774bdd14","33":"4b2adb3a25f33ba3b783","34":"9685935339a08a35ae62","35":"8de8654ae98fa74452ea","36":"fa00713ae50684a4075a","37":"686f1fd0530b0f304afb","38":"f245312826a71caf4f2c","39":"5505a422b6c414747613","40":"a819c141f57c733f4d7f","41":"3f5caa7b165a54052cf6","42":"54a3af1328a48657e1da","43":"8e030305e74ba524cd06","44":"d83ed323f33f5cf1a0db","45":"53d8d219edaa1823706e","46":"99bcb5110a5c3d47c110","47":"29a942eef2f33ac0123b","48":"b651e0968c97bb42a3f9","49":"df70b496578b949c49c1","50":"72edd7ffe446d12b898e","51":"a77ef3430b3ed831aa43","52":"9c768536a5b12e7201bd","53":"e1f6afd27186fc12b1b7","54":"f4dda9eaa59253f72e2e","55":"af6cf24a0fb845e8bcbf","56":"062a513b412263263375","57":"24c0d651a1b812a7fce2","58":"ef7a284ce8d4e2d69427","59":"dcf11837d736ef365554","60":"7389259542d1d229a558","61":"e1b322dfe04aa034ea06","62":"c4b24a051b552dc4dcf8","63":"e985be14c39b358c963f","64":"38be0d83b9425f57d330","65":"9c5d4478477ab867cdff","66":"96bbc7ab6f20cb018b67","67":"4c37ebc2964cdb24543e","68":"e265103f98e81354ac64","69":"dacdb7b5eee4b2c020f6","70":"cd90b53dfc9da1c62956","71":"b8774e57a1c74e6ce012","72":"3aa9e9f671d27769b0e3","73":"4f461b0ba241d5d3a07f","74":"db2224a37ebbc9c3d517","75":"dbb39fe0cc477fd47d06","76":"81c3b0f1bc7a2e2f72ff","77":"7cb298feb7499d358320","78":"01ea1beea4b6080feab5","79":"bbbd1e419e0c5c695dbe","80":"e69d20f04c0dba640f37","81":"2ccdb663307ff3f60e38","82":"4176559e900698440e62","83":"2dcbfb7adcca666b7a20","84":"c8840e7ed59f9bac2ebf","85":"9fd97d05467506efa436","86":"b45d1bd0fada3f90384d","87":"06fc4bf98af966a2e285","88":"aca11af6a89ba572b0a7","89":"f77a28da9e2fae6e093e","90":"f39a3d108ac077d01787","91":"164892d1592761241ce6","92":"2d5d28c1da6f9039dc48","94":"c1484b2d4a9f7b556359","95":"ce9299f318096075f5bb","96":"c8f82ca797956ea51b10","97":"6075bfd3ee2a723de50b","98":"2e78618549716f408cf9","99":"abe70f58719d4f631f74","100":"f319d0b40a20a9f9b316","101":"f9dc6dabb055b2bab768","102":"813608a2293cc8dadb8b","103":"2898144087218aec5ccc","104":"fd4ca37bc417e9cafe03","105":"3189f19e7b28532d5db3","106":"326e0fc06ea5c931840e","107":"551722dea4f8a315bad2","108":"c2d040a435ded2c48e19","109":"0f9d1417939ac45bb64c","110":"2a177385cb7c8ed8829e","111":"6bce68b295713e7fd183","112":"a26a88e8fa50f52406d8","113":"3f18917f94d06f51afe2","114":"4568c40abdd4673becbb","115":"8943d19fea9646065072","116":"6cc2adc59c78e9e00c52","117":"d70ba68ca94116d598fb","118":"c77952bc508df7dad2e8","119":"be37b30f36571a2d1156","120":"eb57a96cd080322a6325","121":"98d4f1844da5a0770e4f","122":"683a65fc0afe5c4baa41","123":"25b104f09e0b7d7fcea4","124":"1c45a50f0dffa0c3983a","125":"0cae150db60269e226b6","126":"e7a1266382dc773a02de","127":"e739f9c11c2216040333","128":"9e7acb502481284a93ff","129":"1fc0a1b9d47237a00d18","130":"2651689a9186c3ee730b","131":"9e25900dc8b34f992405","132":"b3d5195d8de425ca31fd","133":"13cc87e4adfd0f4f5b8a","134":"7e1704231892726a0251","135":"91d974cebc1efd85fdf6","136":"e6c007fd2bfc61c5e7e8","137":"b3d9a0496faa5c36793c","138":"c4ade76308800c945a6d","139":"9ba29311d937bbc9a0a3","140":"0a3864dcdc20277845d9","141":"16bec2a2456b04eb4a52","142":"5f3fdd58c0d292c7730b","143":"b8f6acd639c89f453948","144":"8e967d7f7fc4fe0a93a9","145":"344aa573178d81877224","146":"9825dd51ddf4c6d53d60","147":"10c181f16b5e9d0e177b","148":"bce83b22765d986dc097","149":"1e2ee03145c87214b606","150":"7e002f2a40e871d7115c","151":"a5a4abf6d984b2e95f43","152":"8b3269c0271c989a7029","153":"ba3fe01355d3b9e26496","154":"cbec7355375f371f1297","155":"d38a057819a01c15c452","156":"20bfaeaa248e63df7927","157":"34c84a93446c517340af","158":"f7e91d54de0efe8e9949","159":"dca6dba502519db0c2c3","160":"6d2ab550d04e21baa28f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([759,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
